import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class ProductTrustBadges extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateAvailability);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateAvailability);
  }

  /**
   * Updates badge visibility for the selected variant.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateAvailability = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    this.hidden = event.detail.resource?.available !== true;
  };
}

if (!customElements.get('product-trust-badges')) {
  customElements.define('product-trust-badges', ProductTrustBadges);
}
